export default __webpack_public_path__ + "static/media/eduTwitter.16a23eb4.svg";